import { useQuery } from '@apollo/client';
import { PUBLISH_CONSTRAINTS_QUERY } from '../graphql/resolvers/postQueries/publishConstraints.gql';

export function usePublishConstraints(): {
  minStoryLength: number | null;
  minReplyLength: number | null;
  loading: boolean;
  error: boolean;
  refetch: () => void;
} {
  // cache-and-network so an already-open session picks up a re-tuned floor on
  // the next mount (not just on a hard reload). The gate keys on min === null,
  // NOT loading, so a background revalidation with a cached floor never
  // spuriously re-blocks publish.
  const { data, loading, error, refetch } = useQuery(
    PUBLISH_CONSTRAINTS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
    },
  );
  return {
    minStoryLength: data?.publishConstraints?.minStoryLength ?? null,
    minReplyLength: data?.publishConstraints?.minReplyLength ?? null,
    loading,
    error: Boolean(error),
    refetch: () => {
      void refetch();
    },
  };
}
